<template>
    <popup :opened="dataToShow" @close="close">
        <!-- BEGIN Content modal add hobbie -->
        <div v-if="dataToShow">
            <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
                <h3 v-if="isNewHobbie" class="mb-10">Ajouter un centre d'intérêt</h3>
                <h3 v-if="!isNewHobbie" class="mb-10">Modifier le centre d'intérêt</h3>
                <h6 class="text-indigo-600 mb-8">Saissisez le nom du centre d'intérêt{{(isNewHobbie) ? " à ajouter" : ""}}.</h6>
                <h6 v-if="isNewHobbie" class="text-indigo-600 mb-8">Vous pouvez en ajouter plusieurs à la fois en les séparant d’une virgule.</h6>
                <div class="flex flex-col justify-center items-center">
                    <input-text
                        :error="true"
                        placeholder="Exemple : “Guitare“"
                        :value="hobbieName"
                        class="lg:w-1/2"
                        libelle="Centre d'intérêt"
                        name="hobbieName"
                        @input="(newValue) => {hobbieName = newValue}"
                    />
                </div>

                <div class="flex justify-center mt-15">
                    <action-button
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        :libelle="isNewHobbie ? 'AJOUTER' : 'MODIFIER'"
                        type-shadow="shadow-pink"
                        @clickAction="addHobbie()"
                    />
                </div>

            </div>
        </div>
    </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import Icon from  '../../../components/Icon.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import InputSelect from '../../../components/Inputs/InputSelect.vue';
import DatePicker from '../../../components/Inputs/DatePicker.vue';
import ActionButton from '../../../components/ActionButton.vue';

export default {
  components:{
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
  },

  props:{
    dataToShow:{
      type: Boolean,
      required: false,
      default: false
    },
        
    hobbieToEdit:{
      type:Object,
      required: false,
      default: null,
    },
  },

  data(){
    return {
      hobbieName: '',
    };
  },

  methods:{
    close(){
      this.$emit('close');
      this.hobbieName = '';
    },

    addHobbie(){
      if(this.isNewHobbie){
        this.$emit('addHobbie', this.hobbieName);
      }
      if(!this.isNewHobbie){
        this.$emit('modifyHobbie', this.hobbieName);
      }
            
      this.close();
      this.hobbieName = '';
    },
  },

  computed:{
    isNewHobbie(){
      return this.hobbieToEdit === null;
    }
  },

  watch:{
    dataToShow:{
      handler(){
        if(this.hobbieToEdit){
          this.hobbieName = this.hobbieToEdit.value;
          return;
        }
        this.hobbieName = '';
      },
    },
  }
};
</script>
